import {z} from 'zod';

import {advertisementPayloadSchema} from './AdvertisementPayloadSchema';
import {
  advertisingAdapterErrorCodeSchema,
  advertisingCredentialsSchema,
  advertisingImageSchema,
  advertisingOperationSchema,
  advertisingPlatformCodeSchema,
} from './AdvertisingCommonSchemas';

export const advertisingJobMessageSchema = z.object({
  jobId: z.string().uuid(),
  tenantId: z.string().uuid(),
  vehicleId: z.string().uuid(),
  platformCode: advertisingPlatformCodeSchema,
  operation: advertisingOperationSchema,
  publishingBranchId: z.string().uuid().nullable(),
  externalId: z.string().nullable(),
  vehicle: advertisementPayloadSchema,
  images: z.array(advertisingImageSchema),
  credentials: advertisingCredentialsSchema.nullable(),
});

export const advertisementJobCompletedEventSchema = z.object({
  jobId: z.string().uuid(),
  tenantId: z.string().uuid(),
  status: z.enum(['done', 'failed']),
  publicationId: z.string().uuid().nullable(),
  externalId: z.string().nullable(),
  linkToAd: z.string().nullable(),
  errorCode: advertisingAdapterErrorCodeSchema.nullable(),
  errorMessage: z.string().nullable(),
});

export const advertisingFeedRunMessageSchema = z.object({
  feedRunId: z.string().uuid(),
  tenantId: z.string().uuid(),
  platformCode: advertisingPlatformCodeSchema,
  feedKey: z.string().min(1),
});

export type AdvertisingJobMessage = z.infer<typeof advertisingJobMessageSchema>;
export type AdvertisingFeedRunMessage = z.infer<typeof advertisingFeedRunMessageSchema>;
export type AdvertisementJobCompletedEvent = z.infer<typeof advertisementJobCompletedEventSchema>;
